import { useState } from 'react';
import { Breadcrumbs as MuiBreadcrumbs, breadcrumbsClasses } from '@mui/material';

import { StyledBreadcrumb } from 'Lib/components/common/StyledComponents';
import { screenSize } from 'Lib/utilities/screenSize';

export default function Breadcrumbs(props) {
    const { items, onBreadcrumbDrop, ...rest } = props;
    const lastItem = items.length - 1;
    const [dragIndex, setDragIndex] = useState(null);
    const { mobile } = screenSize();

    const handleClick = (item, last) => {
        if (last) return;
        if (item.onClick) item.onClick();
    };

    const handleDrop = data => {
        setDragIndex(null);
        if (onBreadcrumbDrop) onBreadcrumbDrop(data);
    };

    const handleDragOver = index => event => {
        event.preventDefault();
        setDragIndex(index);
    };

    return (
        <MuiBreadcrumbs
            {...rest}
            sx={{
                pb: 2,
                pl: mobile ? 4 : 0,
                [`& .${breadcrumbsClasses.separator}`]: {
                    fontSize: '12px',
                    alignSelf: 'end',
                    color: theme => theme.palette.common.accentgray
                }
            }}
        >
            {items.map((item, index) => (
                <StyledBreadcrumb
                    key={index}
                    last={lastItem === index}
                    draggedOver={dragIndex === index}
                    component="a"
                    label={item.path}
                    onClick={() => handleClick(item, lastItem === index)}
                    onDrop={() => handleDrop(item)}
                    onDragOver={() => handleDragOver(index)}
                    onDragLeave={() => setDragIndex(null)}
                />
            ))}
        </MuiBreadcrumbs>
    );
}
